
(function($, window, document) {

	// The $ is now locally scoped 

	// Listen for the jQuery ready event on the document
	$(function() { });

	

	// $('.ms-slick-1').slick({
	// 	dots: true,
	// 	speed: 300,
	// 	infinite: true,
	// 	autoplay: false,
	// 	slidesToShow: 1,
	// 	slidesToScroll: 1,
	// 	centerMode: false,
	// 	arrows: true,
	// 	prevArrow: '<span class="slick-prev icon-arrow-left"></span>',
	// 	nextArrow: '<span class="slick-next icon-arrow-right"></span>',
	// 	focusOnSelect: true,
	//     autoplaySpeed: 6000,
	//     // asNavFor: '.lsi-property-slick-nav',
	// });
	// 
	
	

	// $('.ms-slick-2').slick({
	// 	dots: true,
	// 	speed: 600,
	// 	infinite: true,
	// 	autoplay: false,
	// 	slidesToShow: 4,
	// 	slidesToScroll: 1,
	// 	centerMode: false,
	// 	centerPadding: 0,
	// 	arrows: true,
	// 	focusOnSelect: true,
	//     autoplaySpeed: 3000,
	// 	prevArrow: '<span class="slick-prev icon-arrow-left"></span>',
	// 	nextArrow: '<span class="slick-next icon-arrow-right"></span>',
	//     responsive: [
	// 				    {
	// 				      	breakpoint: 991,
	// 				      	settings: {
	// 				        	slidesToShow: 2,
	// 				      	}
	// 				    },
	// 				    {
	// 				      	breakpoint: 500,
	// 				      	settings: {
	// 				        	slidesToShow: 1,
	// 				      	}
	// 				    },
	//     			]
	// });


	$('.ms-assessments-list').slick({
		dots: true,
		speed: 600,
		infinite: true,
		autoplay: false,
		slidesToShow: 2,
		slidesToScroll: 1,
		centerMode: false,
		centerPadding: 0,
		arrows: true,
		focusOnSelect: true,
	    autoplaySpeed: 3000,
		prevArrow: '<span class="slick-prev btn -square icon-arrow-l"></span>',
		nextArrow: '<span class="slick-next btn -square icon-arrow-r"></span>',
	    responsive: [
					    {
					      	breakpoint: 991,
					      	settings: {
					        	slidesToShow: 1,
					      	}
					    },
					    {
					      	breakpoint: 500,
					      	settings: {
					        	slidesToShow: 1,
					      	}
					    },
	    			]
	});


	$('.ms-brands-list.-slick').slick({
		dots: false,
		arrows: false,
		// prevArrow: '<span class="slick-prev btn -square icon-arrow-l"></span>',
		// nextArrow: '<span class="slick-next btn -square icon-arrow-r"></span>',
		speed: 600,
		infinite: true,
		autoplay: true,
	    autoplaySpeed: 1500,
		slidesToShow: 6,
		slidesToScroll: 1,
		centerMode: false,
		centerPadding: 0,
		focusOnSelect: true,
	    responsive: [
					    {
					      	breakpoint: 500,
					      	settings: {
					        	slidesToShow: 3,
					      	}
					    },
	    			]
	});



	$('.ms-slick-text-section .slick-text-gallery').slick({
		dots: false,
		arrows: true,
		prevArrow: '<span class="slick-prev icon-arrow-s-l"></span>',
		nextArrow: '<span class="slick-next icon-arrow-s-r"></span>',
		speed: 600,
		infinite: true,
		autoplay: false,
	    autoplaySpeed: 1500,
		slidesToShow: 1,
		slidesToScroll: 1,
		centerMode: false,
		centerPadding: 0,
		focusOnSelect: true,
	});

	$('.ms-slick-gallery').slick({
		dots: false,
		arrows: true,
		prevArrow: '<span class="slick-prev icon-arrow-s-l"></span>',
		nextArrow: '<span class="slick-next icon-arrow-s-r"></span>',
		speed: 600,
		infinite: true,
		autoplay: false,
	    autoplaySpeed: 1500,
		slidesToShow: 1,
		slidesToScroll: 1,
		centerMode: false,
		centerPadding: 0,
		focusOnSelect: true,
	});



	





	window.addEventListener('resize', function(event){



	});
	

    
}(window.jQuery, window, document));